import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Polygon } from 'react-yandex-maps';

const opacity1 = 0.08;
const opacity2 = 0.18;
const opacity3 = 0.3;
const opacity4 = 0.42;

const getPolygonOpacity = (selectedPolygonId, thisId) => {
  return selectedPolygonId !== undefined
    ? selectedPolygonId === thisId
      ? opacity4
      : opacity1
    : opacity3;
};

export default class MapPolygons extends PureComponent {
  state = {
    isHover: false,
    polygonOpacity: getPolygonOpacity(this.props.selectedPolygonId, this.props.item.polygon_id),
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedPolygonId !== this.props.selectedPolygonId) {
      this.setState({
        polygonOpacity: getPolygonOpacity(nextProps.selectedPolygonId, this.props.item.polygon_id),
      });
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  geometry = [this.props.item.polygon || []];

  onClick = () => {
    this.props.polygonClick(this.props.restaurantId, this.props.item.polygon_id);
  };

  polygonMouseHover = enter => {
    const { selectedPolygonId, item } = this.props;

    if (enter && !this.state.isHover && selectedPolygonId !== item.polygon_id) {
      this.setState({
        polygonOpacity:
          selectedPolygonId !== undefined
            ? selectedPolygonId === item.polygon_id
              ? opacity4
              : opacity2
            : opacity4,
      });

      this.setState({ isHover: true });
    } else if (!enter && this.state.isHover && !this.props.isMarkerHover) {
      this.setState({
        polygonOpacity:
          selectedPolygonId !== undefined
            ? selectedPolygonId === item.polygon_id
              ? opacity4
              : opacity1
            : opacity3,
      });

      this.setState({ isHover: false });
    }
  };

  onMouseLeave = () => {
    this.timer = setTimeout(() => this.polygonMouseHover(false), 50);
  };

  onMouseEnter = () => {
    clearTimeout(this.timer);
    this.polygonMouseHover(true);
  };

  getInstanceRef = geoObject => {
    const { item, restaurantId } = this.props;
    this.props.getGeoObjects({ geoObject, polygon_id: item.polygon_id, restaurantId });
  };

  render() {
    const {
      item,
      hintLayout,
      selectedPolygonId,
      currency,
      name,
      deliveryGroups,
      isOpeningSoon,
    } = this.props;

    const { polygonOpacity } = this.state;

    const deliveryGroup = deliveryGroups.find(group => group.min_sum === item.min_sum) || {};
    const color = deliveryGroup.color || 'rgb(250, 240, 225)';
    const zIndex = deliveryGroup.zIndex || 5;

    const standardPolygonOptions = {
      fillColor: color,
      strokeColor: color,
      fillOpacity: polygonOpacity,
      zIndex,
      strokeWidth: 2,
    };

    const openSoonPolygonOptions = {
      fillColor: 'rgb(128, 128, 128)',
      strokeColor: 'rgb(128, 128, 128)',
      fillOpacity: polygonOpacity,
      strokeWidth: 2,
      hintLayout,
    };

    return (
      <Polygon
        geometry={this.geometry}
        properties={{
          object: 'с 11:00 до 23:00',
          sum: item.min_sum,
          name,
          currency,
        }}
        options={isOpeningSoon ? { ...openSoonPolygonOptions } : { ...standardPolygonOptions }}
        instanceRef={this.getInstanceRef}
        onClick={this.onClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      />
    );
  }
}

MapPolygons.defaultProps = {
  item: [],
  selectedPolygonId: undefined,
  name: '',
  deliveryGroups: [],
  getGeoObjects: f => f,
};

MapPolygons.propTypes = {
  item: PropTypes.object.isRequired,
  polygonClick: PropTypes.func.isRequired,
  restaurantId: PropTypes.number,
  selectedPolygonId: PropTypes.any,
  isMarkerHover: PropTypes.bool,
  hintLayout: PropTypes.func,
  currency: PropTypes.string,
  name: PropTypes.string,
  deliveryGroups: PropTypes.array,
  getGeoObjects: PropTypes.func,
};
